import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetFulfillmentsByOrderInput } from './GetFulfillmentsByOrderInput';
import { GetFulfillmentsByOrderOutput } from './GetFulfillmentsByOrderOutput';

export class GetFulfillmentsByOrderService extends HttpServiceBase {

  constructor(
    http?: any | null
  ) {
    super(http);
  }

  handle = (input: GetFulfillmentsByOrderInput): Promise<Result<GetFulfillmentsByOrderOutput> | null> => {
    const promise = input.updateTrackingNumber
      ? this.http.get<Result<GetFulfillmentsByOrderOutput>>(`${this.baseUrlSislogApi}/v2/order/${input.orderId}/fulfillments-with-updated-tracking-number`)
      : this.http.get<Result<GetFulfillmentsByOrderOutput>>(`${this.baseUrlSislogApi}/v2/order/${input.orderId}/fulfillments`);
    return promise;
  }
}